export const tr = {
    'currency-cost-shows': '{currency} bin gösterim başına',
    'rate-note': 'Yeni ve değiştirilmiş gösterim koşulları için maksimum teklif'
};
